<template>
    <div>
        <b-modal v-model="modal" size="md" hide-header hide-footer>            
            <h2><b>Parabéns!</b></h2>
            <br>
            <h6> Você possuí um pedido bonificado personalizado! </h6>
            <br>
            <b-button block variant="success" @click="modal = false"><i class="fa fa-thumbs-up"></i> Ok</b-button>
        </b-modal>
    </div>
</template>

<script>
// import { defineComponent } from '@vue/composition-api'

export default {
  data () {
    return {
        modal: false,
    }
  },
    name: 'kit-personalizado',
    props: {       
        kit: {
            type: String,
            default: false
        }
    },
    
    methods:{
        loadKit(){
            this.modal = true;
        }
    },  
    mounted() {
        this.loadKit();
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/util/KitPersonalizado.vue